import React from 'react';
import EcoImg from 'eco-design/base/eco-img';
import { StepProps } from '../createStateMachine';
import { RemoteInstallFormContext } from '../index';
import css from '../index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/i18n';

const FormSuccess: React.FC<StepProps<RemoteInstallFormContext>> = ({}) => {
    const { t } = useLang('questionnaire');
    const { locale = 'us' } = getLocal();
    return (
        <div className={css.step}>
            <EcoImg className="FormSuccess-img" pc="https://websiteoss.ecoflow.com/upload/image/1765185490053/NotQualified.png" />
            <div className="FormSuccess-title">{t('success_title')}</div>
            <div className="step-btns">
                <a className="step-btn step-btn-next last-btn" href={`/${locale}`}>
                    {t('btn_submit_success')}
                </a>
            </div>
        </div>
    );
};
export default FormSuccess;
